import { AxiosError, AxiosRequestConfig } from "axios";
import api from "./api-instance";
import type { AxiosDataReturn, PaginatedResponse } from "../types/generic";
import { toast } from "react-toastify";
import type { IReferral } from "../types/referral";
import type { IUserRefund } from "../types/user";
import type { TUserPlan } from "../types/payment";

export const referralsList = async (
  userId: string,
  args?: AxiosRequestConfig<any>
) => {
  try {
    const res = await api.get<PaginatedResponse<IReferral>>(
      `/referrals/admin/${userId}`,
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error("Something went wrong", { toastId: "api-error" });
    throw e;
  }
};

export const initiateRefundPayStack = async (
  userId: string,
  args?: AxiosRequestConfig<any>
) => {
  try {
    const res = await api.post<PaginatedResponse<IReferral>>(
      `/referrals/admin/${userId}/refund`,
      args
    );
    return res?.data?.data;
  } catch (e) {
    console.error({ e });

    const message =
      e instanceof AxiosError
        ? Array.isArray(e?.response?.data?.error)
          ? e?.response?.data?.error?.[0]
          : e?.response?.data?.error ?? e?.response?.data?.message
        : "Something went wrong";
    toast.error(message ?? "Something went wrong", { toastId: "api-error" });
    throw e;
  }
};

export const getUserProcessedRefund = async (
  userId: string,
  args?: AxiosRequestConfig<any>
) => {
  try {
    const res = await api.get<AxiosDataReturn<IUserRefund>>(
      `/referrals/admin/${userId}/refund`,
      args
    );
    return res?.data?.data;
  } catch (e) {
    console.error({ e });
    const message =
      e instanceof AxiosError
        ? Array.isArray(e?.response?.data?.error)
          ? e?.response?.data?.error?.[0]
          : e?.response?.data?.error ?? e?.response?.data?.message
        : "Something went wrong";
    toast.error(message ?? "Something went wrong", { toastId: "api-error" });
    throw e;
  }
};

export const getLastPaymentDetailsByUserId = async (
  userId: string,
  args?: AxiosRequestConfig<any>
) => {
  try {
    const res = await api.get<AxiosDataReturn<TUserPlan | null>>(
      `/referrals/admin/${userId}/payment`,
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error("Something went wrong", { toastId: "api-error" });
    throw e;
  }
};
